export default __webpack_public_path__ + "static/media/chapterLock.790fabbf.svg";